import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message } from "antd";
import {
  FetchRISIDetailAction,
  FetchRISIDropdownAction,
  FetchRISISecondaryDropdownAction,

  FetchRISIDropdownV2Action,
  FetchRISISecondaryDropdownV2Action,
  FetchRISIDetailV2Action,
} from "../../../redux/action/RISIAction";
import {
  getBUsForSupplierFilters,
  getSectorsForSupplierFilters,
  getYears,
  getSectors,
  getRoles,
  getBusinessUnitsBySector,
  getCommoditiesForRISI,
  getIndexesForRISI,
  getLocationsForRISI,
  changeToDateOptionsUtil,
  changeFromDateOptionsUtil
} from "../../KPIOverview/KpiUtils";
import {FetchSPGlobalPageLabelCountAction} from "../../../redux/action/SPGlobalAction";
import {
  getOverlappingOptionsV2,
  getMonthsWithYearWithMaxDate,
  getToDateOptionsWithMaxDate,
  getMonthsWithYearRangeAdjustedForMaxDate,
  transformIndexData,
  getAdditionalDisplayTexts,
  getFirstUniqueItems
} from "../../../utils/utils";
import { useToast } from "../../../components/Toast/ToastContext";
import Vector from "../../../assets/Vector.png";

// This context/provider owns ALL RISI (FASTMARKETS) state, redux selectors,
// handler functions and effects - ported over from the standalone
// RISIScreen.js - so RISI logic is fully self-contained and can be
// consumed by <RisiSource/> as just another source of SBACCIScreen.js,
// mirroring the CMA/Woodmac/SmartCube source pattern.
const RisiSourceContext = createContext(null);

export const useRisiSource = () => useContext(RisiSourceContext);

const DEFAULT_RISI_L0 = [{ id: 1, displayText: "GP DIRECTS" }];
const DEFAULT_RISI_L1 = [{ id: 1, displayText: "PACKAGING" }];
const MAX_OPTIONS_SELECTION_ALLOWED = 5;
const MIN_RISI_YEAR = 2023;
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const date = new Date();
const currentYear = date.getFullYear();
const DEFAULT_FROM_DATE_YEAR = currentYear - 1;
const DEFAULT_TO_DATE_YEAR = currentYear + 1;
const DEFAULT_TO_DATE = "Dec " + DEFAULT_TO_DATE_YEAR;

export const RisiSourceProvider = ({ children, isUserDataFetched, isRisiSelected, l1Category, l2Category }) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const landingPageData = useSelector(state => state.getLandingPageReducer);
  // const primaryDropdownData = useSelector(state => state.getRISIDropdownReducer);
  const primaryDropdownData = useSelector(state => state.getRISIDropdownV2Reducer);
  // const risiData = useSelector(state => state.getRISIDetailReducer);
  const risiData = useSelector(state => state.getRISIDetailV2Reducer);
  // const secondaryDropdownData = useSelector(state => state.getRISISecondaryDropdownReducer);
  const secondaryDropdownData = useSelector(state => state.getRISISecondaryDropdownV2Reducer);

  const [isDataLoading, setIsDataLoading] = useState(false);

  const [roleSelected, setRoleSelected] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [sectorSelected, setSectorSelected] = useState([]);
  const [userSectors, setUserSectors] = useState([]);
  const [businessUnits, setBusinessUnits] = useState([]);
  const [businessUnitSelected, setBusinessUnitSelected] = useState([]);
  const [userBusinessUnits, setUserBusinessUnits] = useState([]);
  const [allBUs, setAllBUs] = useState([]);
  const [categoryL0Selected, setCategoryL0Selected] = useState([]);
  const [categoryL1Selected, setCategoryL1Selected] = useState([]);
  const [fromDates, setFromDates] = useState([]);
  const [toDates, setToDates] = useState([]);
  const [fromDateSelected, setFromDateSelected] = useState("");
  const [toDateSelected, setToDateSelected] = useState("");
  const [entireMonthList, setEntireMonthList] = useState([]);

  const [commodities, setCommodities] = useState([]);
  const [commoditySelected, setCommoditySelected] = useState([]);
  const [indexes, setIndexes] = useState([]);
  const [indexSelected, setIndexSelected] = useState([]);
  const [locations, setLocations] = useState([]);
  const [locationSelected, setLocationSelected] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [currencySelected, setCurrencySelected] = useState([]);
  const [indexMapping, setIndexMapping] = useState({});
  const [firstForecastYearMonth, setFirstForecastYearMonth] = useState("");
  const [firstForecastKeysToBeMergedActualLAst, setFirstForecastKeysToBeMergedActualLAst] = useState([]);
  const [lineChartactualData, setLineChartActualData] = useState([]);

  const [switcherIndex, setSwitcherIndex] = useState(0);
  const [chartData, setChartData] = useState([]);
  const [forecastStartVal, setForecastStartVal] = useState("");
  const [risiSeriesLineChartIndex, setRisiSeriesLineChartIndex] = useState([]);
  const [risiLineChartLegends, setRisiLineChartLegends] = useState([]);

  const risiLineChartRef = useRef();
  const risiModalRef = useRef();

  const risiTableColumns = [
    { columnKey: "commodityId", header: "Commodity ID", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "commodityDescription", header: "Commodity Description", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "indexId", header: "Index ID", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "indexDescription", header: "Index Description", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "risiLocation", header: "RISI Location", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "currency", header: "Currency", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "incoTerms", header: "INCO Terms", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "assessmentFrequency", header: "Assessment Frequency", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "latestPriceLow", header: "Latest Price (low)", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "latestPriceMid", header: "Latest Price (mid)", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "latestPriceHigh", header: "Latest Price (high)", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "unitOfMeasure", header: "Unit of Measure", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: "latestAssessmentDate", header: "Latest Assessment Date", size: 90, minSize: 90, maxSize: 140 }
  ];

  const risiTableColumnMapping = {
    commodityId: "Commodity ID",
    commodityDescription: "Commodity Description",
    indexId: "Index ID",
    indexDescription: "Index Description",
    risiLocation: "RISI Location",
    currency: "Currency",
    incoTerms: "INCO Terms",
    assessmentFrequency: "Assessment Frequency",
    latestPriceLow: "Latest Price (low)",
    latestPriceMid: "Latest Price (mid)",
    latestPriceHigh: "Latest Price (high)",
    unitOfMeasure: "Unit of Measure",
    latestAssessmentDate: "Latest Assessment Date"
  };

  const risiColumnsToInclude = [
    "Commodity ID",
    "Commodity Description",
    "Index ID",
    "Index Description",
    "RISI Location",
    "Currency",
    "INCO Terms",
    "Assessment Frequency",
    "Latest Price (low)",
    "Latest Price (mid)",
    "Latest Price (high)",
    "Unit of Measure",
    "Latest Assessment Date"
  ];

  const risiTableData = risiData?.risiTableViewDtoList;
  const risiLineChartData = risiData?.risiLineChartResponseDto;
  const risiLineChartSeriesKeys = risiData?.risiLineChartIndexDto;
  const seriesColors = ["#33ABDA", "#B05788", "#0078A7", "#8458CC", "#FFCC49"];

  const productCount = risiData?.risiData?.productCount;
  const lastUpdate = risiData?.risiData?.lastUpdate;
  const refreshFrequency = risiData?.risiData?.refreshFrequency;
  const appOwnersList = risiData?.owners;

  // Fetch the RISI dropdown hierarchy whenever RISI becomes the active
  // source (covers both an initial default-RISI page load and switching
  // back to RISI from another source), once user info has been fetched -
  // mirrors CmaSourceProvider's isCmaSelected-gated fetch, replacing
  // RISIScreen's own standalone fetchUserInfo effect (user/landing page
  // data is already fetched once by the parent SBACCIScreen).
  /* istanbul ignore next */
  useEffect(() => {
    if (isUserDataFetched && isRisiSelected && landingPageData && landingPageData.type === "SUCCESS_LANDING_PAGE_ACTION") {
      localStorage.setItem("firstRequest_risi", true);

      setCategoryL1Selected(DEFAULT_RISI_L1);
      setCategoryL0Selected(DEFAULT_RISI_L0);

      const Roles = getRoles(landingPageData.details);
      const defaultRole = landingPageData?.defaultRole;
      setRoleSelected([{ id: 1, displayText: defaultRole }]);
      const defaultRoleObject = Roles.filter(item => item.displayText === landingPageData.defaultRole);

      const getUserInfoByRole = landingPageData?.details?.filter(item => item.role === defaultRoleObject[0]?.displayText)?.[0];
      const sectorsData = getSectors(getUserInfoByRole?.roleDetail);
      const sectorsToInclude = sectorsData?.map(item => item.displayText);
      setUserSectors(sectorsData);

      const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
      setUserBusinessUnits(BUs);

      setIsDataLoading(true);
      const location = window.location.pathname;
      dispatch(FetchSPGlobalPageLabelCountAction(location));

      const sectorData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));
      const buData = JSON.parse(localStorage.getItem("BUsSelected_risi"));
      const selectedRole = roleSelected?.[0]?.displayText || "";
      const firstReq = localStorage.getItem("firstRequest_risi");
      const requestObject = {
      role: selectedRole,
      sector: sectorData?.map(item => (item.displayText ? item.displayText : item)),
      bu: buData?.map(item => (item.displayText ? item.displayText : item)),
      userSector: userSectors?.map(item => (item.displayText ? item.displayText : item)),
      userBu: userBusinessUnits?.map(item => (item.displayText ? item.displayText : item)),
      firstRequest: firstReq === "true" ? true : false,
      l1Category: l1Category || "",
      l2Category: l2Category || "",
    };
      // dispatch(FetchRISIDropdownAction());
      
      dispatch(FetchRISIDropdownV2Action(requestObject));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserDataFetched, isRisiSelected, landingPageData]);

  /* istanbul ignore next */
  useEffect(() => {
    // if (risiData && risiData.type === "SUCCESS_RISI_DETAIL_VIEW_ACTION") {
    if (risiData && risiData.type === "SUCCESS_RISI_DETAIL_VIEW_V2_ACTION") {
      setIsDataLoading(false);
    }
  }, [risiData]);

  /* istanbul ignore next */
  useEffect(() => {
    // if (isUserDataFetched && primaryDropdownData && primaryDropdownData.type === "SUCCESS_RISI_DROPDOWN_ACTION") {
    if (isUserDataFetched && primaryDropdownData && primaryDropdownData.type === "SUCCESS_RISI_DROPDOWN_V2_ACTION") {
      const dropdownData = primaryDropdownData;

      const sectorsData = getSectorsForSupplierFilters(dropdownData?.sectorBu);
      localStorage.setItem("sectorsSelected_risi", JSON.stringify(sectorsData));
      setSectorSelected(sectorsData);
      setSectors(sectorsData);
      const sectorsToInclude = sectorsData?.map(item => (item.displayText ? item.displayText : item));

      const BUs = getBUsForSupplierFilters(dropdownData?.sectorBu, sectorsToInclude);
      localStorage.setItem("BUsSelected_risi", JSON.stringify(BUs));
      setBusinessUnitSelected(BUs);
      setBusinessUnits(BUs);
      setAllBUs(BUs);

      const capabilitySearchKey = "RISI";
      const maxDateForApps = [{ ...primaryDropdownData?.maxDate, appName: "RISI" }];
      const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

      let maxYearValue;
      const maxYearMonth = maxDateObject?.maxYearMonth;
      if (maxYearMonth) {
        const [, maxYearText] = maxYearMonth.split(" ");
        maxYearValue = parseInt(maxYearText, 10);
      }
      const yearsArray = [];
      for (let i = MIN_RISI_YEAR; i <= maxYearValue; i++) {
        yearsArray.push(i);
      }

      const allYears = getYears(yearsArray);

      const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
      setFromDates(fromDate);

      setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(Number(allYears[0]?.displayText), Number(allYears[allYears.length - 1]?.displayText), capabilitySearchKey, maxDateForApps));

      const yearSelected = DEFAULT_FROM_DATE_YEAR;
      const fromDateMonth = "Jan";
      const objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);

      const tempFromDate = fromDate.filter(item => item.displayText === fromDateMonth + " " + yearSelected);

      let tempToDate = fromDate.filter(item => {
        const currentLastMonth = Number(yearSelected) < objectYear ? "Dec " + yearSelected : maxYearMonth;
        return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
      });

      const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.["displayText"], maxDateObject);
      setToDates(toDateOptions);

      const defaultToDateOption = toDateOptions.filter(item => item.displayText === DEFAULT_TO_DATE);
      if (defaultToDateOption && defaultToDateOption.length > 0) {
        tempToDate = defaultToDateOption;
      } else {
        tempToDate = [toDateOptions[toDateOptions.length - 1]];
      }

      const index = fromDate.findIndex(item => item.displayText === tempToDate[0]?.displayText);
      if (index !== -1) {
        setFromDates(fromDate.slice(0, index + 1));
      }
      setFromDateSelected(tempFromDate);
      setToDateSelected(tempToDate);

      localStorage.setItem("fromDateSelected_risi", JSON.stringify(tempFromDate));
      localStorage.setItem("toDateSelected_risi", JSON.stringify(tempToDate));
      loadSecondaryDropdownData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primaryDropdownData]);



  /* istanbul ignore next */
  useEffect(() => {
    // if (isUserDataFetched && secondaryDropdownData && secondaryDropdownData.type === "SUCCESS_RISI_SEC_DROPDOWN_ACTION") {
    if (isUserDataFetched && secondaryDropdownData && secondaryDropdownData.type === "SUCCESS_RISI_SEC_DROPDOWN_V2_ACTION") {
      const dropdownData = secondaryDropdownData;

      setIndexMapping(transformIndexData(dropdownData?.commodity));
      const commoditiesData = getCommoditiesForRISI(dropdownData?.commodity);
      setCommodities(commoditiesData);
      const commoditiesToSelect = getOverlappingOptionsV2(commoditiesData, secondaryDropdownData?.defaultCommodity);
      setCommoditySelected(commoditiesToSelect);
      localStorage.setItem("commoditiesSelected_risi", JSON.stringify(commoditiesToSelect));

      const commoditiesToInclude = commoditiesToSelect?.map(item => item.displayText);
      const indexesData = getIndexesForRISI(dropdownData?.commodity, commoditiesToInclude);
      setIndexes(indexesData);
      const indexesToSelect = getOverlappingOptionsV2(indexesData, secondaryDropdownData?.defaultIndex);
      setIndexSelected(indexesToSelect);
      localStorage.setItem("indexesSelected_risi", JSON.stringify(indexesToSelect));

      const indexesToInclude = indexesToSelect?.map(item => item.displayText);
      const locationsData = getLocationsForRISI(dropdownData?.commodity, commoditiesToInclude, indexesToInclude);
      setLocations(locationsData);
      const locationsToSelect = getOverlappingOptionsV2(locationsData, secondaryDropdownData?.defaultLocation);
      setLocationSelected(locationsToSelect);
      localStorage.setItem("locationsSelected_risi", JSON.stringify(locationsToSelect));

      const currenciesFromApi = Array.isArray(dropdownData?.currency)
        ? dropdownData.currency.map(item => ({ id: item, displayText: item }))
        : [];
      setCurrencies(currenciesFromApi);

      const defaultCurrency = currenciesFromApi.length > 0 ? [currenciesFromApi[0]] : [];
      setCurrencySelected(defaultCurrency);
      localStorage.setItem("currenciesSelected_risi", JSON.stringify(defaultCurrency));
      loadKPIPageData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondaryDropdownData]);


  /* istanbul ignore next */
  const loadSecondaryDropdownData = () => {
    const sectorData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));
    const buData = JSON.parse(localStorage.getItem("BUsSelected_risi"));
    const selectedRole = roleSelected?.[0]?.displayText || "";
    const firstReq = localStorage.getItem("firstRequest_risi");
    const requestObject = {
      role: selectedRole,
      sector: sectorData?.map(item => (item.displayText ? item.displayText : item)),
      bu: buData?.map(item => (item.displayText ? item.displayText : item)),
      userSector: userSectors?.map(item => (item.displayText ? item.displayText : item)),
      userBu: userBusinessUnits?.map(item => (item.displayText ? item.displayText : item)),
      firstRequest: firstReq === "true" ? true : false,
      l1Category: l1Category || "",
      l2Category: l2Category || "",
    };
    setIsDataLoading(true);
    // dispatch(FetchRISISecondaryDropdownAction(requestObject));
    
    dispatch(FetchRISISecondaryDropdownV2Action(requestObject));
    localStorage.setItem("firstRequest_risi", false);
  };

  /* istanbul ignore next */
  const loadKPIPageData = () => {
    const sectorsData = JSON.parse(localStorage.getItem("sectorsSelected_risi"));
    const BUsData = JSON.parse(localStorage.getItem("BUsSelected_risi"));
    const categoryL0Data = categoryL0Selected;
    const categoryL1Data = categoryL1Selected;
    const fromDateData = JSON.parse(localStorage.getItem("fromDateSelected_risi"));
    const toDateData = JSON.parse(localStorage.getItem("toDateSelected_risi"));

    const commodityData = JSON.parse(localStorage.getItem("commoditiesSelected_risi"));
    const indexData = JSON.parse(localStorage.getItem("indexesSelected_risi"));
    const locationData = JSON.parse(localStorage.getItem("locationsSelected_risi"));
    const currencyData = JSON.parse(localStorage.getItem("currenciesSelected_risi"));

    if (
      sectorsData?.length > 0 &&
      BUsData?.length > 0 &&
      categoryL0Data?.length > 0 &&
      categoryL1Data?.length > 0 &&
      fromDateData?.length > 0 &&
      toDateData?.length > 0 &&
      commodityData?.length > 0 &&
      indexData?.length > 0 &&
      locationData?.length > 0 &&
      currencyData?.length > 0
    ) {
      const selectedCurrency = Array.isArray(currencyData)
        ? currencyData?.[0]?.displayText ? currencyData[0].displayText : currencyData?.[0]
        : currencyData?.displayText ? currencyData.displayText : currencyData;

      const requestObject = {
        fromDate: fromDateData?.[0]?.value || "",
        toDate: toDateData?.[0]?.value || "",
        sector: sectorsData?.map(item => (item.displayText ? item.displayText : item)),
        bu: BUsData?.map(item => (item.displayText ? item.displayText : item)),
        l0: categoryL0Data?.map(item => item.displayText),
        l1: categoryL1Data?.map(item => item.displayText),
        commodity: commodityData?.map(item => item.displayText),
        index: indexData?.map(item => item.displayText),
        location: locationData?.map(item => item.displayText),
        currency: selectedCurrency || "",
        l1Category: l1Category || "",
        l2Category: l2Category || "",
      };

      setIsDataLoading(true);
      // dispatch(FetchRISIDetailAction(requestObject));
      dispatch(FetchRISIDetailV2Action(requestObject));
    } else {
      message.warning("Please select required filters");
    }
  };

  /* istanbul ignore next */
  const onCommodityChange = val => {
    if (val && val.length > MAX_OPTIONS_SELECTION_ALLOWED) {
      message.warning("Please select at max " + MAX_OPTIONS_SELECTION_ALLOWED + " commodities");
      setCommoditySelected(JSON.parse(localStorage.getItem("commoditiesSelected_risi")));
      return;
    }
    if (val && val.length > 0) {
      const previousCommoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"));
      const newCommoditiesSelected = val;
      const previousIndexes = JSON.parse(localStorage.getItem("indexesSelected_risi"));
      if (previousCommoditiesSelected.length > newCommoditiesSelected.length) {
        const removedCommodityOption = getAdditionalDisplayTexts(previousCommoditiesSelected, newCommoditiesSelected);
        const previousIndexesStrList = previousIndexes?.map(item => item.displayText);

        const commoditiesToInclude = newCommoditiesSelected?.map(item => item.displayText);
        const indexesData = getIndexesForRISI(secondaryDropdownData?.commodity, commoditiesToInclude);
        setIndexes(indexesData);
        const indexesToSelect = getOverlappingOptionsV2(indexesData, previousIndexesStrList);
        setIndexSelected(indexesToSelect);
        localStorage.setItem("indexesSelected_risi", JSON.stringify(indexesToSelect));

        const indexesToInclude = indexesToSelect?.map(item => item.displayText);
        const locationsData = getLocationsForRISI(secondaryDropdownData?.commodity, commoditiesToInclude, indexesToInclude);
        setLocations(locationsData);
        setLocationSelected(locationsData);
        localStorage.setItem("locationsSelected_risi", JSON.stringify(locationsData));

        localStorage.setItem("commoditiesSelected_risi", JSON.stringify(val));
        setCommoditySelected(val);
        loadKPIPageData();
      } else {
        const addedCommodityOption = getAdditionalDisplayTexts(newCommoditiesSelected, previousCommoditiesSelected);
        const allIndexOptionsIntheCommodity = indexMapping?.[addedCommodityOption?.[0]];
        const previousIndexesStrList = previousIndexes?.map(item => item.displayText);

        if (previousIndexes.length >= 5) {
          message.warning("At max " + MAX_OPTIONS_SELECTION_ALLOWED + " indices can be selected.");
          setCommoditySelected(JSON.parse(localStorage.getItem("commoditiesSelected_risi")));
          return;
        }
        const newIndexOptionsAvailableToAdd = MAX_OPTIONS_SELECTION_ALLOWED - previousIndexes.length;
        const newIndexOptionsToSelect = getFirstUniqueItems(allIndexOptionsIntheCommodity, previousIndexesStrList, newIndexOptionsAvailableToAdd);

        const commoditiesToInclude = newCommoditiesSelected?.map(item => item.displayText);
        const indexesData = getIndexesForRISI(secondaryDropdownData?.commodity, commoditiesToInclude);
        setIndexes(indexesData);
        const merge = (a, b) => [...new Set([...a, ...b])];
        const mergedIndexList = merge(previousIndexesStrList, newIndexOptionsToSelect);
        const indexesToSelect = getOverlappingOptionsV2(indexesData, mergedIndexList);
        setIndexSelected(indexesToSelect);
        localStorage.setItem("indexesSelected_risi", JSON.stringify(indexesToSelect));

        const indexesToInclude = indexesToSelect?.map(item => item.displayText);
        const locationsData = getLocationsForRISI(secondaryDropdownData?.commodity, commoditiesToInclude, indexesToInclude);
        setLocations(locationsData);
        setLocationSelected(locationsData);
        localStorage.setItem("locationsSelected_risi", JSON.stringify(locationsData));

        localStorage.setItem("commoditiesSelected_risi", JSON.stringify(val));
        setCommoditySelected(val);
        loadKPIPageData();
      }
    } else if (val && val.length === 0) {
      setCommoditySelected([]);
      localStorage.setItem("commoditiesSelected_risi", JSON.stringify([]));
      setIndexSelected([]);
      localStorage.setItem("indexesSelected_risi", JSON.stringify([]));
      setLocationSelected([]);
      localStorage.setItem("locationsSelected_risi", JSON.stringify([]));
      message.warning("At least one commodity is required");
    }
  };

  /* istanbul ignore next */
  const onIndexChange = val => {
    if (val && val.length > MAX_OPTIONS_SELECTION_ALLOWED) {
      message.warning("Please select at max " + MAX_OPTIONS_SELECTION_ALLOWED + " indices");
      setIndexSelected(JSON.parse(localStorage.getItem("indexesSelected_risi")));
      return;
    }
    if (val && val.length > 0) {
      setIndexSelected(val);
      localStorage.setItem("indexesSelected_risi", JSON.stringify(val));

      const commoditiesSelected = JSON.parse(localStorage.getItem("commoditiesSelected_risi"));
      const commoditiesToInclude = commoditiesSelected?.map(item => item.displayText);
      const indexesToInclude = val?.map(item => item.displayText);
      const locationsData = getLocationsForRISI(secondaryDropdownData?.commodity, commoditiesToInclude, indexesToInclude);
      setLocations(locationsData);
      setLocationSelected(locationsData);
      localStorage.setItem("locationsSelected_risi", JSON.stringify(locationsData));
      loadKPIPageData();
    } else if (val && val.length === 0) {
      setIndexSelected([]);
      localStorage.setItem("indexesSelected_risi", JSON.stringify([]));
      setLocationSelected([]);
      localStorage.setItem("locationsSelected_risi", JSON.stringify([]));
      message.warning("At least one index is required");
    }
  };

  /* istanbul ignore next */
  const onLocationChange = val => {
    if (val && val.length > MAX_OPTIONS_SELECTION_ALLOWED) {
      message.warning("Please select at max " + MAX_OPTIONS_SELECTION_ALLOWED + " locations");
      setLocationSelected(JSON.parse(localStorage.getItem("locationsSelected_risi")));
      return;
    }
    if (val && val.length > 0) {
      setLocationSelected(val);
      localStorage.setItem("locationsSelected_risi", JSON.stringify(val));
      loadKPIPageData();
    } else if (val && val.length === 0) {
      setLocationSelected([]);
      localStorage.setItem("locationsSelected_risi", JSON.stringify([]));
      message.warning("At least one location is required");
    }
  };

  /* istanbul ignore next */
  const onCurrencyChange = val => {
    if (val && val.length > 0) {
      setCurrencySelected(val);
      localStorage.setItem("currenciesSelected_risi", JSON.stringify(val));
      loadKPIPageData();
    } else if (val && val.length === 0) {
      setCurrencySelected([]);
      localStorage.setItem("currenciesSelected_risi", JSON.stringify([]));
      message.warning("At least one currency is required");
    }
  };

  /* istanbul ignore next */
  const onSectorChange = val => {
    if (val && val.length > 0) {
      const sectorsToInclude = val?.map(item => (item.displayText ? item.displayText : item));
      const BUs = getBUsForSupplierFilters(primaryDropdownData?.sectorBu, sectorsToInclude);
      setSectorSelected(val);
      localStorage.setItem("sectorsSelected_risi", JSON.stringify(val));

      localStorage.setItem("BUsSelected_risi", JSON.stringify(BUs));
      setBusinessUnits(BUs);
      setBusinessUnitSelected(BUs);
      loadSecondaryDropdownData();
    } else if (val && val.length === 0) {
      message.warning("At least one sector is required");
      setBusinessUnitSelected([]);
      setSectorSelected([]);
      localStorage.setItem("BUsSelected_risi", JSON.stringify([]));
      localStorage.setItem("sectorsSelected_risi", JSON.stringify([]));
    }
  };

  /* istanbul ignore next */
  const onBusinessUnitChange = val => {
    if (val && val.length > 0) {
      if (sectorSelected.length > 0) {
        setBusinessUnitSelected(val);
        localStorage.setItem("BUsSelected_risi", JSON.stringify(val));
        loadSecondaryDropdownData();
      } else {
        message.warning("Please select at least one sector");
      }
    } else if (val && val.length === 0) {
      message.warning("At least one business unit / market is required");
      localStorage.setItem("BUSeleceted_suppliers", JSON.stringify([]));
      setBusinessUnitSelected([]);
    }
  };

  /* istanbul ignore next */
  const onFromDateChange = val => {
    if (val && val.length > 0) {
      setFromDateSelected(val);
      localStorage.setItem("fromDateSelected_risi", JSON.stringify(val));

      const maxDateForApps = [{ ...primaryDropdownData?.maxDate, appName: "RISI" }];
      const capabilitySearchKey = "RISI";
      const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
      const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]["displayText"], maxDateObject);
      setToDates(toDateOptions1);

      const tempY = val[0]["displayText"]?.split(" ")?.[1];
      const date1 = new Date(val[0]["displayText"]);
      const date2 = new Date(toDateSelected?.[0]?.["displayText"]);
      const date2Year = date2?.getFullYear();
      const toDateMonth = months[date2?.getMonth()];

      const tempToDate = toDateOptions1?.filter(item => item.displayText === "Dec " + tempY);
      const customTempToDate = toDateOptions1?.filter(item => item.displayText === `${toDateMonth} ` + date2Year);
      changeToDateOptions(val[0]);

      if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
        if (date1 <= date2) {
          setToDateSelected(customTempToDate);
          localStorage.setItem("toDateSelected_risi", JSON.stringify(customTempToDate));
          loadKPIPageData();
        } else {
          setToDateSelected(tempToDate);
          localStorage.setItem("toDateSelected_risi", JSON.stringify(tempToDate));
          loadKPIPageData();
        }
      } else {
        loadKPIPageData();
      }
    } else {
      message.warning("From Date is not selected");
    }
  };

  /* istanbul ignore next */
  const onToDateChange = val => {
    if (val && val.length > 0) {
      setToDateSelected(val);
      localStorage.setItem("toDateSelected_risi", JSON.stringify(val));
      changeFromDateOptions(val[0]);
      loadKPIPageData();
    } else {
      message.warning("To Date is not selected");
    }
  };

  /* istanbul ignore next */
  const changeFromDateOptions = toDateMonthSelected => {
    setFromDates(changeFromDateOptionsUtil(toDateMonthSelected, entireMonthList));
  };

  /* istanbul ignore next */
  const changeToDateOptions = fromDateMonthSelected => {
    setToDates(changeToDateOptionsUtil(fromDateMonthSelected, entireMonthList));
  };

  /* istanbul ignore next */
  const onFiltersReset = () => {
    setSectorSelected(sectors);
    localStorage.setItem("sectorsSelected_risi", JSON.stringify(sectors));
    setBusinessUnitSelected(allBUs);
    localStorage.setItem("BUsSelected_risi", JSON.stringify(allBUs));

    localStorage.setItem("firstRequest_risi", true);

    const maxDateForApps = [{ ...primaryDropdownData?.maxDate, appName: "RISI" }];
    const capabilitySearchKey = "RISI";
    const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

    const maxYearMonth = maxDateObject?.maxYearMonth;
    let maxYearValue;
    if (maxYearMonth) {
      const [, maxYearText] = maxYearMonth.split(" ");
      maxYearValue = parseInt(maxYearText, 10);
    }
    const yearsArray = [];
    for (let i = MIN_RISI_YEAR; i <= maxYearValue; i++) {
      yearsArray.push(i);
    }

    const allYears = getYears(yearsArray);
    const minYear = Number(allYears[0]?.displayText);
    const maxYear = Number(allYears[allYears.length - 1]?.displayText);

    setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));

    const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject);
    setFromDates(fromDate);

    const yearSelected = DEFAULT_FROM_DATE_YEAR;
    const fromDateMonth = "Jan";

    const tempFromDate = fromDate.filter(item => item.displayText === fromDateMonth + " " + yearSelected);
    const objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);

    let tempToDate = fromDate.filter(item => {
      const currentLastMonth = Number(yearSelected) < objectYear ? "Dec " + yearSelected : maxYearMonth;
      return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
    });

    const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.["displayText"], maxDateObject);
    setToDates(toDateOptions);

    const defaultToDateOption = toDateOptions.filter(item => item.displayText === DEFAULT_TO_DATE);
    if (defaultToDateOption && defaultToDateOption.length > 0) {
      tempToDate = defaultToDateOption;
    } else {
      tempToDate = [toDateOptions[toDateOptions.length - 1]];
    }

    setFromDateSelected(tempFromDate);
    localStorage.setItem("fromDateSelected_risi", JSON.stringify(tempFromDate));

    setToDateSelected(tempToDate);
    localStorage.setItem("toDateSelected_risi", JSON.stringify(tempToDate));

    const index = fromDate.findIndex(item => item.displayText === tempToDate[0]?.displayText);
    if (index !== -1) {
      setFromDates(fromDate.slice(0, index + 1));
    }

    loadSecondaryDropdownData();
  };

  // Merge actual + forecast line-chart series (identical logic to the
  // standalone RISIScreen) whenever the switcher (Low/Mid/High) or the
  // underlying chart data/series keys change.
  useEffect(() => {
    const getCombinedData = switchIndex => {
      const level = switchIndex == 0 ? "low" : switchIndex == 1 ? "mid" : "high";
      const { actual = [], forecast = [] } = risiLineChartData?.[level] || {};

      if (!actual.length) return forecast;
      if (!forecast.length) return actual;

      const lastThreeActuals = actual.slice(-3);
      const firstThreeForecasts = forecast.slice(0, 3);

      const forecastMap = new Map(firstThreeForecasts.map(item => [item.yearMonth, item]));

      let isFirstSet = false;

      const mergedActuals = actual.map(act => {
        const forecastMatch = forecastMap.get(act.yearMonth);
        if (forecastMatch) {
          if (!isFirstSet) {
            setFirstForecastYearMonth(forecastMatch.yearMonth);
            isFirstSet = true;
          }
          return { ...act, ...forecastMatch, isForecastLabel: true };
        }
        return act;
      });

      const mergedMonths = new Set(lastThreeActuals.map(a => a.yearMonth));
      const remainingForecasts = forecast.filter(f => !mergedMonths.has(f.yearMonth));
      return [...mergedActuals, ...remainingForecasts];
    };

    function getForecastStartMonth(data) {
      const level = switcherIndex === 0 ? "low" : switcherIndex === 1 ? "mid" : "high";
      const actual = data?.[level]?.actual || [];
      const forecast = data?.[level]?.forecast || [];

      setLineChartActualData(actual);
      if (!actual.length && !forecast.length) return null;

      const lastThreeActuals = actual.slice(-3);
      const firstThreeForecasts = forecast.slice(0, 3);

      const forecastMonths = new Set(firstThreeForecasts.map(f => f.yearMonth));
      const firstMerged = lastThreeActuals.find(a => forecastMonths.has(a.yearMonth));

      if (firstMerged) return firstMerged.yearMonth;

      return forecast?.[0]?.yearMonth || null;
    }

    const forecastStart = getForecastStartMonth(risiLineChartData);
    const modifiedRisiLineChartData = getCombinedData(switcherIndex);

    const risiSeriesLineChartVal = risiLineChartSeriesKeys?.map((item, index) => ({
      ...item,
      color: seriesColors[index % seriesColors.length]
    }));

    const risiLineChartLegendsVal = risiLineChartSeriesKeys?.map((item, index) => ({
      name: item.key,
      color: seriesColors[index % seriesColors.length]
    }));

    setRisiLineChartLegends(risiLineChartLegendsVal);
    setRisiSeriesLineChartIndex(risiSeriesLineChartVal);
    setChartData(modifiedRisiLineChartData);
    setForecastStartVal(forecastStart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [switcherIndex, risiLineChartData, risiLineChartSeriesKeys]);

  useEffect(() => {
    return () => {
      dispatch({ type: "RESET_RISI_DROPDOWN_ACTION", payload: "RESET_RISI_DROPDOWN_ACTION" });
      dispatch({ type: "RESET_RISI_SEC_DROPDOWN_ACTION", payload: "RESET_RISI_SEC_DROPDOWN_ACTION" });
      dispatch({ type: "RESET_RISI_DETAIL_VIEW_ACTION", payload: "RESET_RISI_DETAIL_VIEW_ACTION" });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* istanbul ignore next */
  const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
    if (isPdfDownloaded) {
      if (isModal) {
        showToast("success", !isJpeg ? "PDF of full page successfully downloaded." : "JPEG of full page successfully downloaded.", {
          icon: <img src={Vector} alt="image" style={{ width: "20px", height: "20px" }} />
        });
      } else if (isTable) {
        showToast("success", !isJpeg ? "PDF of a table successfully downloaded." : "JPEG of a table successfully downloaded.", {
          icon: <img src={Vector} alt="image" style={{ width: "20px", height: "20px" }} />
        });
      } else {
        showToast("success", !isJpeg ? "PDF of a chart successfully downloaded." : "JPEG of a chart successfully downloaded.", {
          icon: <img src={Vector} alt="image" style={{ width: "20px", height: "20px" }} />
        });
      }
    } else {
      showToast("Error", "Failed to download. Please try again.", {
        icon: <img src={Vector} alt="image" style={{ width: "20px", height: "20px" }} />
      });
    }
  };

  const value = {
    risiData,
    isDataLoading,
    roleSelected,
    sectors, sectorSelected, onSectorChange,
    businessUnits, businessUnitSelected, onBusinessUnitChange,
    categoryL0Selected, categoryL1Selected,
    fromDates, toDates, fromDateSelected, toDateSelected, onFromDateChange, onToDateChange,
    commodities, commoditySelected, onCommodityChange,
    indexes, indexSelected, onIndexChange,
    locations, locationSelected, onLocationChange,
    currencies, currencySelected, onCurrencyChange,
    onFiltersReset,
    switcherIndex, setSwitcherIndex,
    chartData, forecastStartVal, risiSeriesLineChartIndex, risiLineChartLegends,
    firstForecastYearMonth, firstForecastKeysToBeMergedActualLAst, lineChartactualData,
    risiTableData, risiTableColumns, risiTableColumnMapping, risiColumnsToInclude,
    risiLineChartRef, risiModalRef,
    checkPDFDownloaded,
    appOwnersList, productCount, lastUpdate, refreshFrequency
  };

  return <RisiSourceContext.Provider value={value}>{children}</RisiSourceContext.Provider>;
};
